import { render, staticRenderFns } from "./InboxPermissions.vue?vue&type=template&id=1631a1d6&scoped=true&"
import script from "./InboxPermissions.vue?vue&type=script&lang=js&"
export * from "./InboxPermissions.vue?vue&type=script&lang=js&"
import style0 from "./InboxPermissions.vue?vue&type=style&index=0&id=1631a1d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1631a1d6",
  null
  
)

export default component.exports